import { render, staticRenderFns } from "./statisticsOfInterval.vue?vue&type=template&id=54af61ec&scoped=true"
import script from "./statisticsOfInterval.vue?vue&type=script&lang=js"
export * from "./statisticsOfInterval.vue?vue&type=script&lang=js"
import style0 from "./statisticsOfInterval.vue?vue&type=style&index=0&id=54af61ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af61ec",
  null
  
)

export default component.exports